import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../store/slices/auth";
import userReducer from "../store/slices/user";
import luckyDrawReducer from "../store/slices/luckydraw";
import projectReducer from "../store/slices/project";
import galleryReducer from "../store/slices/gallery"


const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  luckyDraw: luckyDrawReducer,
  projectlist: projectReducer,
  gallerylist: galleryReducer

});

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});
export default store;
